<div class="flex flex-col gap-2 items-center justify-center mt-1">
    <h3 class="text-center text-base">Select type of calls to remove:</h3>
    <div class="flex gap-1 mb-2">
        <p-button *ngIf="isLeah() || allowedRoles()" styleClass="btn btn-primary btn-xxs px-2 py-1 text-xs"
            (click)="selectedType = 'mc'">Recruiting</p-button>
        <p-button *ngIf="isAlissa() || allowedRoles()" styleClass="btn btn-primary btn-xxs px-2 py-1 text-xs"
            (click)="selectedType = 'roots'">Roots</p-button>
        <p-button *ngIf="isAlissa() || allowedRoles()" styleClass="btn btn-primary btn-xxs px-2 py-1 text-xs"
            (click)="selectedType = 'consulting'">Consulting</p-button>
    </div>
</div>

<div>
    <ng-container *ngIf="selectedType === 'mc'">
        <app-remove-old-calls-mc />
    </ng-container>
    <ng-container *ngIf="selectedType === 'roots'">
        <app-remove-old-calls-roots />
    </ng-container>

    <ng-container *ngIf='selectedType === "consulting"'>
        <app-remove-old-consulting-calls></app-remove-old-consulting-calls>
    </ng-container>
</div>